import React from 'react';
import { translate } from 'react-i18next';
import AdminStepCard from '../../../components/AdminStepCard/AdminStepCard';
import LabeledSelect from '../../../components/LabeledSelect/LabeledSelect';

import './AccessProfile.scss';

const AccessProfile = ({options, setting, handleSettingPropChange, ...props}) => {
    let { t: translate } = props;
    const t = (prop) => translate(`workplanManager:settings.${prop}`)
    const placeholder =  t('placeholders.hyperfinds')

    const handleCreateTemplateChange = (value) => handleSettingPropChange('createTemplatesHyperfind', value);
    const handleManageShitlineChange = (value) => handleSettingPropChange('manageShiftlinesHyperfind', value);
    const handleManageAssignmentChange = (value) => handleSettingPropChange('manageAssignmentsHyperfind', value);

    return (
        <AdminStepCard avatar={2} title={t('accessProfile')} >
            <div className='selects-container'>
                <LabeledSelect
                    options={options}
                    value={setting.createTemplatesHyperfind}
                    label={t('createTemplates')}
                    handleChange={handleCreateTemplateChange}
                    widthSize="lg"
                    error={!setting.createTemplatesHyperfind}
                    placeholder={placeholder}
                    sorted
                />
                <LabeledSelect
                    options={options}
                    value={setting.manageShiftlinesHyperfind}
                    label={t('manageShiftlines')}
                    handleChange={handleManageShitlineChange}
                    widthSize="lg"
                    error={!setting.manageShiftlinesHyperfind}
                    placeholder={placeholder}
                    sorted
                />
                <LabeledSelect
                    options={options}
                    value={setting.manageAssignmentsHyperfind}
                    label={t('manageAssignments')}
                    handleChange={handleManageAssignmentChange}
                    widthSize="lg"
                    error={!setting.manageAssignmentsHyperfind}
                    placeholder={placeholder}
                    sorted
                />
            </div>
        </AdminStepCard>
    )
}
export default translate('workplanManager')(AccessProfile);
